(function () {
  var KEY = 'diamoray_wishlist';

  function getItems() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function saveItems(items) { localStorage.setItem(KEY, JSON.stringify(items)); }
  function indexOfHandle(items, handle) {
    for (var i = 0; i < items.length; i++) { if (items[i].handle === handle) return i; }
    return -1;
  }

  function syncHearts() {
    var items = getItems();
    var btns = document.querySelectorAll('.wishlist-heart-btn');
    for (var i = 0; i < btns.length; i++) {
      btns[i].classList.toggle('is-active', indexOfHandle(items, btns[i].dataset.handle) > -1);
    }
  }

  // little jump on the header heart whenever the list changes
  function pulseTrigger() {
    var t = document.querySelector('.wishlist-header-trigger');
    if (!t) return;
    t.classList.remove('pop');
    void t.offsetWidth;
    t.classList.add('pop');
  }

  function updateTrigger() {
    var t = document.querySelector('.wishlist-header-trigger');
    if (!t) return;
    t.classList.toggle('has-items', getItems().length > 0);
  }

  function renderPanel() {
    var list = document.querySelector('.wishlist-panel__list');
    var empty = document.querySelector('.wishlist-panel__empty');
    if (!list) return;
    var items = getItems();
    list.innerHTML = '';
    if (items.length === 0) { if (empty) empty.style.display = 'block'; return; }
    if (empty) empty.style.display = 'none';

    items.forEach(function (item) {
      var li = document.createElement('li');
      li.className = 'wishlist-panel__item';

      var a = document.createElement('a');
      a.className = 'wishlist-panel__link';
      a.href = item.url;

      var img = document.createElement('img');
      img.className = 'wishlist-panel__img';
      img.src = item.image; img.alt = ''; img.loading = 'lazy';

      var info = document.createElement('span');
      info.className = 'wishlist-panel__info';
      var name = document.createElement('span');
      name.className = 'wishlist-panel__name';
      name.textContent = item.title;
      var price = document.createElement('span');
      price.className = 'wishlist-panel__price';
      var now = document.createElement('span');
      now.className = 'wishlist-panel__price-now';
      now.textContent = item.price;
      price.appendChild(now);
      if (item.compare) {
        var was = document.createElement('span');
        was.className = 'wishlist-panel__price-was';
        was.textContent = item.compare;
        price.appendChild(was);
      }
      info.appendChild(name); info.appendChild(price);
      a.appendChild(img); a.appendChild(info);

      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'wishlist-panel__remove';
      remove.dataset.handle = item.handle;
      remove.setAttribute('aria-label', 'Remove');
      remove.innerHTML = '&times;';

      li.appendChild(a);
      li.appendChild(remove);
      list.appendChild(li);
    });
  }

  function openPanel() {
    var p = document.querySelector('.wishlist-panel');
    var o = document.querySelector('.wishlist-overlay');
    if (p) { p.classList.add('is-open'); p.setAttribute('aria-hidden', 'false'); }
    if (o) o.classList.add('is-open');
  }
  function closePanel() {
    var p = document.querySelector('.wishlist-panel');
    var o = document.querySelector('.wishlist-overlay');
    if (p) { p.classList.remove('is-open'); p.setAttribute('aria-hidden', 'true'); }
    if (o) o.classList.remove('is-open');
  }

  function toggleItem(btn) {
    var items = getItems();
    var handle = btn.dataset.handle;
    var idx = indexOfHandle(items, handle);
    if (idx > -1) { items.splice(idx, 1); }
    else {
      items.push({
        handle: handle,
        title: btn.dataset.title,
        url: btn.dataset.url,
        price: btn.dataset.price,
        compare: btn.dataset.compare,
        image: btn.dataset.image
      });
      btn.classList.add('just-added');
      setTimeout(function () { btn.classList.remove('just-added'); }, 350);
    }
    saveItems(items); syncHearts(); renderPanel(); updateTrigger(); pulseTrigger();
  }
  function removeItem(handle) {
    var items = getItems();
    var idx = indexOfHandle(items, handle);
    if (idx > -1) { items.splice(idx, 1); saveItems(items); }
    syncHearts(); renderPanel(); updateTrigger(); pulseTrigger();
  }

  function init() {
    syncHearts(); renderPanel(); updateTrigger();

    document.addEventListener('click', function (e) {
      var heart = e.target.closest('.wishlist-heart-btn');
      if (heart) { e.preventDefault(); e.stopPropagation(); toggleItem(heart); return; }

      var rm = e.target.closest('.wishlist-panel__remove');
      if (rm) { removeItem(rm.dataset.handle); return; }

      if (e.target.closest('.wishlist-header-trigger')) { openPanel(); return; }
      if (e.target.closest('.wishlist-panel__close') || e.target.classList.contains('wishlist-overlay')) { closePanel(); }
    });

    if ('MutationObserver' in window) {
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(syncHearts, 150); })
        .observe(document.body, { childList: true, subtree: true });
    }
    window.addEventListener('pageshow', syncHearts);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();